module.exports = __webpack_public_path__ + "assets/img/logo-paynow-creditcard3d.2220ac3e.png";